import React from "react";
import {Box, Button, Divider, Grid, makeStyles, Typography} from "@material-ui/core";
import clsx from "clsx";
import {useStores} from "../../hooks/use-stores";
import {useTranslation} from "react-i18next";
import {ContentPageStyles} from "./styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useTheme} from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import {starFishColor} from "../../components/styles";

const continueEducation = [
    {
        title: "business_insights",
        links: [
            { titleKey: "links.us_en", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2FBusiness%20Insights%20-%20(US).pdf?alt=media&token=b5bead04-c6f5-465c-b145-ab99e9708573" },
            { titleKey: "links.us_es", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2FBusiness%20Insights%20-%20(US)%20Spanish.pdf?alt=media&token=c30430a1-b32d-46ca-8581-139a1c6b9312" },
            { titleKey: "links.ca_en", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2FBusiness%20Insights%20-%20(CA).pdf?alt=media&token=20c9c77a-5895-4347-a1b1-fc68d20abcc0" },
            { titleKey: "links.ca_fr", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2FBusiness%20Insights%20-%20(CA)%20French.pdf?alt=media&token=36c417c6-b5a9-4d95-b112-1d364af92379" },
        ]
    },
    {
        title: "income_claims",
        links: [
            { titleKey: "links.us_en", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2FIncome%20Claims%20Education%20-%20US%20-%20English.pdf?alt=media&token=40eee358-a084-4e92-ac24-ee7057de75d0" },
            { titleKey: "links.us_es", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2FIncome%20Claims%20Education%20-%20US%20-%20Spanish.pdf?alt=media&token=b8ca5ce1-8cc4-43b2-86cf-c068a0016ebe" },
            { titleKey: "links.ca_en", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2FIncome%20Claims%20Education%20-%20CA%20-%20English.pdf?alt=media&token=eb581e21-3b54-4e41-92f4-70dde0c9039d" },
            { titleKey: "links.ca_fr", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2FIncome%20Claims%20Education%20-%20CA%20-%20French.pdf?alt=media&token=0b2f0113-3672-40c1-9a68-9d8fb46c4c84" },
        ]
    },
    {
        title: "lifestyle_claims",
        links: [
            { titleKey: "links.us_en", link: "https://resources.lifeinfoapp.com/forms/Lifestyle%20Claims%20-%20(US)_Eng.pdf" },
            { titleKey: "links.us_es", link: "https://resources.lifeinfoapp.com/forms/Lifestyle%20Claims%20-%20(US)_Spanish.pdf" },
            { titleKey: "links.ca_en", link: "https://resources.lifeinfoapp.com/forms/Lifestyle%20Claims%20-%20(CA)_Eng.pdf" },
            { titleKey: "links.ca_fr", link: "https://resources.lifeinfoapp.com/forms/Lifestyle%20Claims%20-%20(CA)_French.pdf" },
        ]
    },
    {
        title: "product_claims",
        links: [
            { titleKey: "links.us_en", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2Fus_productclaiminformation_en.pdf?alt=media&token=a4314bfa-5567-49ab-b18e-eca2d90251cc" },
            { titleKey: "links.us_es", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2FSpanish%20-%20Product%20Claim%20Education%20-%20(US).pdf?alt=media&token=4882dcd7-0f18-4715-b8e8-c23f97bbc33f" },
            { titleKey: "links.ca_en", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2Fca_productclaiminformation_en.pdf?alt=media&token=e11a03ad-2621-4b47-8a5c-f1f7ffed5bb2" },
            { titleKey: "links.ca_fr", link: "https://firebasestorage.googleapis.com/v0/b/adminlifeinfoapp.appspot.com/o/forms%2FProduct%20Claim%20Education%20-%20(CA)%20FR.pdf?alt=media&token=8474add2-1701-4682-8fb9-8e2ce9db418f" },
        ]
    },
]

const useStyles = makeStyles((theme) => ({
    ...ContentPageStyles(theme),

    marginBottom:{
        marginBottom: theme.spacing(2)
    },

    circle:{
        width: 80,
        height: 80,
        borderRadius: "50%",
        ...starFishColor(theme, "borderColor"),
        ...starFishColor(theme, "backgroundColor"),
        borderStyle: "solid",
        borderWidth: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 30,
        fontWeight: "bold",
        padding: 10,
        marginBottom: 20,
        [theme.breakpoints.down("700")]: {
            fontSize: 20,
            marginBottom: 10,
            width: 50,
            height: 50,
            padding: 5,

        }
    },


    linkWithButton: {
        padding: 10,
        whiteSpace: "nowrap",
        width: "100%",
        justifyContent: "space-around",
    }
    ,

    divider:{
        marginRight:-1,
        backgroundColor: "rgba(255, 255, 255, 0.42)",
        [theme.breakpoints.down("700")]: {
           marginRight:"unset",
           height:"1px",
            width:"80%",
            marginBottom:20,
            marginTop:20
        },
    },

    link:{
        ...starFishColor(),
        padding: "4px 0",
        display:"block",
    }

}));

const audios = {
    en: "https://resources.lifeinfoapp.com/fms/LIFE/FullComplianceAudio.mp3",
    fr: "https://resources.lifeinfoapp.com/fms/LIFE/FullComplianceAudioFR.mp3",
    es: "https://resources.lifeinfoapp.com/fms/LIFE/FullComplianceAudioES.wav"
}


function Compliance(){
    const { audioStore, commonStore } = useStores();
    const {t} = useTranslation("starfish");
    const theme = useTheme();
    const isPhone = useMediaQuery(theme.breakpoints.down("700"));
    const classes = useStyles();
    const handleAudio = (lang) => {

        const url = audios[lang]

        audioStore.setMedia({direct:true
            , mediaID:"Compliance"
            , title:"Compliance Training Audio", mediaURL:url})
    }


    return <div>
        <section className={clsx( classes.sectionDense)}>
            <img
                src={ `/img/compliance-${commonStore.language}.jpg` }
                className={classes.middleImage} role="img"/>
        </section>
        <section className={clsx( classes.section)}>
            <Grid  container spacing={isPhone?0:3} alignItems="center" justifyContent={"center"}>
                <Grid item container sm={4} direction="column" alignItems="center" justifyContent={"center"}>

                    <Box display="flex"  alignItems={"center"} className={classes.circle }>
                      1
                    </Box>
                        <Typography align={"center"} className={clsx( classes.mainText )} variant="subtitle1">{t("compliance_page.listen")}</Typography>

                    <Box display="flex"  alignItems={"center"} justifyContent={"spaceBetween"} className={classes.linkWithButton }>
                        <Button variant="contained" color="primary" onClick={()=>{ handleAudio("en")}} >{t("english")}</Button>
                        <Button variant="contained" color="primary" onClick={()=>{ handleAudio("fr")}} >{t("french")}</Button>
                        <Button variant="contained" color="primary" onClick={()=>{ handleAudio("es")}} >{t("spanish")}</Button>

                    </Box>
                </Grid>
                <Divider  flexItem  orientation={isPhone?"horizontal":"vertical"} className={classes.divider}/>
                <Grid item container sm={4} direction="column" alignItems="center" justifyContent={"center"}>

                    <Box display="flex"  alignItems={"center"} className={classes.circle }>
                       2
                    </Box>
                        <Typography align={"center"} className={clsx( classes.mainText )} variant="subtitle1">{t("compliance_page.test")}</Typography>

                    <Box display="flex"  alignItems={"center"} justifyContent={"spaceBetween"}  className={classes.linkWithButton }>
                        <Button variant="contained" color="primary" component={Link} to={"/royalstarfish/userprofile/complianceTest?lang=en"} >{t("english")}</Button>
                        <Button variant="contained" color="primary" component={Link} to={"/royalstarfish/userprofile/complianceTest?lang=fr"} >{t("french")}</Button>
                        <Button variant="contained" color="primary" component={Link} to={"/royalstarfish/userprofile/complianceTest?lang=es"} >{t("spanish")}</Button>
                    </Box>
                </Grid>
                <Divider flexItem  orientation={isPhone?"horizontal":"vertical"}  className={classes.divider} />
                <Grid item container sm={4} direction="column" alignItems="center" justifyContent={"center"}>
                    <Box display="flex"  alignItems={"center"} className={classes.circle }>
                        3
                    </Box>

                    <Typography align={"center"} className={clsx( classes.mainText )} variant="subtitle1">{t("compliance_page.review")}</Typography>
                    <Box display="flex"  alignItems={"center"}  className={classes.linkWithButton }>
                        <Button variant="contained" color="primary" download target="_blank" href={"https://resources.lifeinfoapp.com/forms/US_ComplianceMonthEndOverview_EN.pdf"} >{t("english")}</Button>
                        <Button variant="contained" color="primary" download target="_blank" href={"https://resources.lifeinfoapp.com/forms/compliance_month_end_overview_fr.pdf"}>{t("french")}</Button>
                        <Button variant="contained" color="primary" download target="_blank" href={"https://resources.lifeinfoapp.com/forms/compliance_month_end_overview_Spanish.pdf"}>{t("spanish")}</Button>
                    </Box>
                </Grid>
            </Grid>
        </section>
        <section className={clsx( classes.section)}>
            {' '}
        </section>
        <section>
            <Grid  container spacing={isPhone?0:3} alignItems="center" justifyContent={"center"}>
                <Grid item container sm={4} direction="column" alignItems="center" justifyContent={"center"}>
                <Box display="flex"  alignItems={"center"} className={classes.circle }>
                    4
                </Box>
                <Typography align={"center"} className={clsx( classes.mainText )} variant="subtitle1">{t("compliance_page.continuing_education")}</Typography>
                </Grid>
            </Grid>
        </section>
        <section>
            <Grid  container spacing={isPhone?0:3} alignItems="center" justifyContent={"center"}>
                {continueEducation.map(block=>{
                    return (
                        <Grid item container sm={6} xs={12} direction="column" alignItems="center" justifyContent={"center"} key={block.title}>
                           <div>
                               <Typography align={"left"} className={clsx( classes.mainText )} variant="subtitle1">{t(`compliance_page.${block.title}`)}</Typography>
                                {block.links.map(link=>{
                                    return <a className={classes.link} href={link.link} target={"_blank"}  key={link.titleKey}>{t(`compliance_page.${link.titleKey}`)}</a>
                                })}
                            </div>
                        </Grid>)
                })}
            </Grid>
        </section>


        <section className={clsx( classes.section)}>
        {' '}
        </section>

    </div>
}

export default Compliance